export default function LoadSpinner() {
	return (
		<div id="load-spinner" className="if u-justify-center u-margin-top-small">
			<svg
				className="if loader dots horizontal"
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 64 64"
			>
				<title>Loading</title>
				<g className="if svg g">
					<circle
						className="if svg circle"
						fill="#331e11"
						cx="8"
						cy="32"
						r="8"
					/>
					<circle
						className="if svg circle"
						fill="#331e11"
						cx="32"
						cy="32"
						r="8"
					/>
					<circle
						className="if svg circle"
						fill="#331e11"
						cx="56"
						cy="32"
						r="8"
					/>
				</g>
			</svg>
		</div>
	);
}
